exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media screen and (min-width:500px){.rc-anchor{transform:scale(.8);transform-origin:0 0}}.recaptcha-centered #g-recaptcha>div{margin:auto}", ""]);

// exports
